<template>
    <div>
        <vue-dropzone :ref="prefixId + getIdNumber + getLang"
                      :id="prefixId + getIdNumber + getLang"
                      :options="Object.assign({}, JSON.parse(JSON.stringify(dropzoneOptions)), {acceptedFiles: acceptedContentTypes, clickable: ['#' + prefixId + '-uploadBtn' + getIdNumber + getLang, '#' + prefixId + getIdNumber + getLang], accept: acceptHandler.bind(this, width, height, prefixId), renameFile: renameAndSetDtoProperty.bind(this, getRenameProperty), maxFilesize: maxSize, withCredentials: true})"
                      @vdropzone-success="dropzoneSuccessHandler"
                      @vdropzone-error="preErrorHandler"
                      @vdropzone-sending="removeImgAll"
                      @vdropzone-thumbnail="thumbnailHandler"
                      @vdropzone-removed-file="imgRemove"></vue-dropzone>

        <span style="float: right;" class="notice-text"> {{ getFileDescStr }}, {{ getFileSizeStr }} </span><br>
        <div style="margin-bottom: 10px;">
            <b-button type="button" :id="prefixId + '-uploadBtn' + getIdNumber + getLang">upload</b-button>
            <span v-if="isImgLink" style="margin-left: 10px;">

                <b-button type="button" :href="getImgLink" class="ml-3" target="_blank">download</b-button>
            </span>
        </div>
    </div>
</template>

<script>
    import vue2Dropzone from 'vue2-dropzone'

    export default {
        name: "BtnDropzone",
        components: {
            vueDropzone: vue2Dropzone
        },
        props: {
            lang: String,
            prefixId: String,
            fileName: String,
            width: Number,
            height: Number,
            maxSize: Number,
            acceptedContentTypes: String,
            checkCondition: Function,
            dropzoneOptions: Object,
            preObject: Object,
            targetName: String,
            errorHandler: Function,
            idNumber: Number,
            thumbnailTrigger: Boolean
        },
        data() {
            return {
                fullUrl: '',
                targetObj: {},
                targetProperty: ''
            }
        },
        watch: {
            thumbnailTrigger(newVal, oldVal) {
                console.log('thumbnailTrigger')
                console.log(newVal)
                if (newVal  != null) {
                    this.updateImgLink()
                    if (this.fullUrl == null || this.fullUrl === '') {
                        this.removeImgAll()
                    } else {
                        this.setThumbnail()
                    }
                }
            },
        },
        mounted() {
            this.updateImgLink()
            if (this.fullUrl == null || this.fullUrl === '') {
                this.removeImgAll()
            } else {
                this.setThumbnail()
            }
        },
        computed: {
            getFileDescStr() {
                const imgRegex = /image\//gi
                const videoRegex = /video\//gi

                if (this.acceptedContentTypes === '' && this.width != null && this.height != null) {
                    return this.width + ' x ' + this.height
                } else if (this.acceptedContentTypes.startsWith('image')) {
                    if (this.width != null && this.height != null) {
                        return this.acceptedContentTypes.replace(imgRegex, '') + '  ' + this.width + ' x ' + this.height
                    } else {
                        return this.acceptedContentTypes.replace(imgRegex, '') + '  '
                    }
                } else if (this.acceptedContentTypes.startsWith('video')) {
                    return this.acceptedContentTypes.replace(videoRegex, '')
                } else {
                    return ''
                }
            },
            getFileSizeStr() {
                return this.maxSize < 1 ? this.maxSize * 1000 + 'KB 이하' : this.maxSize + 'MB 이하'
            },
            getItem() {
                let str = this.getImgLink.split('/')
                console.log(str)
                return { url: this.getImgLink, label: str[str.length -1]}
            },
            getLang() {
                if (this.lang != null) {
                    return this.lang
                }
                return ''
            },
            getAcceptedType() {
                if (this.acceptedContentTypes.startsWith('video')) {
                    return 'video'
                } else if (this.acceptedContentTypes.startsWith('image')) {
                    return 'image'
                } else {
                    return ''
                }
            },
            isVideo() {
                if (this.acceptedContentTypes.startsWith('video') && this.fullUrl !== '') {
                    return true
                }

                return false
            },
            isImage() {
                if (this.acceptedContentTypes.startsWith('image') && this.fullUrl !== '') {
                    return true
                }

                return false
            },
            getIdNumber() {
                return this.idNumber ? '' + this.idNumber : ''
            },
            isImgLink() {
                if (this.fullUrl == null || this.fullUrl ==='') {
                    return false
                }
                return true
            },
            getImgLink() {
                return this.fullUrl
            },
            getRenameProperty() {
                let fileName = this.fileName
                if (fileName == null || fileName === '') {
                    fileName = 'contentUrl'
                }
                return {lang: this.getLang, name: fileName}
            }
        },
        methods: {
            updateImgLink() {
                if (this.preObject == null || this.targetName == null) {
                    return ''
                }

                // this.targetObj = this.preObject
                // this.targetProperty = this.targetName
                this.fullUrl = this.preObject[this.targetName]? this.preObject[this.targetName] : ''

                // this.fullUrl =this.targetObj[this.targetProperty]
                this.$emit('triggerComputed')
            },
            setThumbnail() {
                console.log('setThumbnail')
                console.log(this.preObject[this.targetObj])
                if (this.preObject != null && this.targetName != null && this.preObject[this.targetName] == null) {
                    this.preObject[this.targetName] = ''
                }
                if (this.getImgLink) {
                    this.$refs[this.prefixId + this.getIdNumber + this.getLang].manuallyAddFile({
                        pregDtoParam: {
                            lang: this.getLang,
                            // name: this.prefixId + this.getLang,
                            name: this.prefixId,
                            uploadUrl: this.getImgLink,
                            isMultiple: false
                        },
                    }, this.getImgLink)
                }
            },
            dropzoneSuccessHandler (file, response) {
                console.log('preSuccessHandler')
                console.log(file.size)
                console.log(file.width + ', ' + file.height)

                this.preObject[this.targetName] = response.desc

                this.updateImgLink()
            },
            preErrorHandler (file, message, xhr) {
                console.log('error')
                console.log(file)
                console.log(message)
                console.log(xhr)

                if (message != null && message.code === 'api.response.auth.notLogin') {
                    alert('로그인이 필요합니다.')
                    this.$router.push({name: 'login'})
                } else {
                    this.removeImgAll()
                    alert(message)

                    if (typeof this.errorHandler === 'function') {
                        this.errorHandler(file, message, xhr)
                    }
                }
            },
            imgRemove(file) {
                this.preObject[this.targetName] = ''
                this.fullUrl = this.preObject[this.targetName]

                console.log('imgRemove')
                console.log(this.preObject)
            },
            removeImgAll() {
                this.$refs[this.prefixId + this.getIdNumber + this.getLang].removeAllFiles(false)
                this.$refs[this.prefixId + this.getIdNumber + this.getLang].setOption('maxFiles', null)
            },
            acceptHandler (width, height, name, file, done) {
                console.log('acceptHandler')
                console.log(file)

                if (width != null && height != null) {
                    let limitByDimension = (fileWidth, fileHeight) => {
                        const reason = ' 사이즈 가이드를 다시 확인하세요. (' + width + 'x' + height + ')'
                        if (fileWidth !== width || fileHeight !== height) {
                            done(reason)
                        } else {
                            done()
                        }
                    }
                    file.limitByDimension = limitByDimension
                } else {
                    let limitByDimension = (fileWidth, fileHeight) => {
                        console.log(fileWidth, fileHeight)
                        done()
                    }
                    file.limitByDimension = limitByDimension
                }
            },
            thumbnailHandler(file, dataUrl) {
                console.log('thumbhnailHandler')
                console.log(file)

                if(typeof file.limitByDimension === 'function') {
                    file.limitByDimension(file.width, file.height)
                }
            },
            renameAndSetDtoProperty(objDtoParam, file) {
                console.log('renameAndSetDtoProperty')
                console.log(file)
                console.log(objDtoParam)
                const objDtoParamDefault = {
                    lang: '',
                    isMultiple: false,
                    name: ''
                }
                file.pregDtoParam = Object.assign({}, objDtoParamDefault, objDtoParam)

                console.log('renameAndSe****************************************')

                console.log(objDtoParam)
                return objDtoParam.name + '.' + file.type.split('/')[1]
            },
        }
    }
</script>
<style scoped>
    /*.vue-dropzone {*/
    /*width: 300px;*/
    /*}*/
    upload-contents {
        margin: 30px;
        border: 30px solid #dddddd;
        padding: 30px;
    }

    .notice-text {
        color: lightcoral;
    }
</style>
